import React from 'react'
import { styled, SxProps } from '@mui/material'
import { muiTypography, muiColors } from '../../../../theme/src/mui/DefaultTheme'

export type MuiErrorProps = {
  error: string
  styleOverrides?: SxProps
  isGroupedOutlined?: boolean
}

const Div = styled('div')({})

const styles = {
  ...muiTypography.body.label,
  color: muiColors.primary.errorRedMain,
  fontSize: '14px',
  margin: '-11px 0 12px 0.75rem',
  '&.groupedOutlined': {
    fontSize: '12px',
    margin: '0 0 0 0.75rem',
    position: 'absolute'
  }
}

const MuiErrorMessage = (
  {
    error,
    styleOverrides,
    isGroupedOutlined = false
  }: MuiErrorProps
) => (
  <>
    <Div
      sx={{ ...styles, ...styleOverrides }}
      {...(isGroupedOutlined && { className: 'groupedOutlined' })}
      data-testid="mui-error-msg"
    >
      {error}
    </Div>
  </>
)

export default MuiErrorMessage
